export const keuringMixin = {
    data() {
        return  {
            keuringstatus: [{text:'Afgekeurd',value:0},{text:'Goedgekeurd',value:1},{text:'Verlopen',value:-3},{text:'Onbekend',value:-1},{text:'NVT',value:-2}],
            keuringsstatus: [-3,-2,-1,0,1],
            keuringcolor: ['warning','default','primary','danger','success'],
            keuringicon: {
                '-3': 'exclamation-triangle',
                '-2': 'minus',
                '-1': 'question',
                '0': 'times',
                '1': 'check'
            },
        }
    },
    computed: {},
    watch: {},
    mounted () {
        
    },
    methods: {},
          
}